<div class="card-body">
    <h4 class="mb-3 text-black d-inline-block">
        <strong>Permissions</strong>
    </h4>

    <form #f="ngForm" class="row mt-3 d-flex flex-column align-items-center">
        <div ngModelGroup="passGroup" password-matcher #passGroup="ngModelGroup" class="col-12 col-md-6 col-sm-6">
            <div class="col-12 col-md-12 col-sm-12">
                <div class="d-flex flex-column form-group py-0">
                    <label class="form-control-label" for="admin-password">Admin password</label>
                    <input type="password"
                           class="form-control"
                           name="adminPassword"
                           [(ngModel)]="adminPassword"
                           #adminPasswordControl="ngModel"
                           required
                           id="admin-password">
                    <div class="form-control-error"
                         *ngIf="!adminPasswordControl.valid && (adminPasswordControl.touched || state.isSubmitted)">
                        <ul>
                            <li *ngIf="adminPasswordControl?.errors?.required">Admin Password is required.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-sm-12">
                <div class="d-flex flex-column form-group py-0">
                    <label class="form-control-label" for="admin-password-confirmation">Confirm Admin password</label>
                    <input type="password"
                           class="form-control"
                           name="adminPasswordConfirmation"
                           [(ngModel)]="adminPasswordConfirmation"
                           #adminPasswordConfirmationControl="ngModel"
                           required
                           id="admin-password-confirmation">
                    <div class="form-control-error"
                         *ngIf="(!adminPasswordConfirmationControl.valid || passGroup?.errors?.nomatch) && (adminPasswordConfirmationControl.touched || state.isSubmitted)">
                        <ul>
                            <li *ngIf="adminPasswordConfirmationControl?.errors?.required">Confirm Admin Password is required.</li>
                            <li *ngIf="passGroup?.errors?.nomatch && adminPasswordConfirmationControl.touched">Password Mismatch</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-sm-12">
                <button type="button"
                        class="btn btn-primary mr-2 mr-md-3"
                        (click)="validate()">Validate</button>
            </div>
        </div>
    </form>

</div>